import classnames from 'classnames';

interface OriginalSearchTermProps {
    queryUsed: string;
    originalQuery?: string;
    containerClass?: string;
    renderLink: (originalQuery: string, queryUsed: string) => React.ReactNode;
}

const OriginalSearchTerm = ({
    queryUsed,
    originalQuery,
    containerClass,
    renderLink,
}: OriginalSearchTermProps) => {
    if (!originalQuery || queryUsed === originalQuery) {
        return null;
    }

    return (
        <span className={classnames(containerClass)}>{renderLink(originalQuery, queryUsed)}</span>
    );
};

export default OriginalSearchTerm;
